import axios from "@/lib/axios";

const getLostNonWarrantyRequest = () => {
  return axios.get("/customer/flat_rates/lost_non_warranty_request");
}

export default getLostNonWarrantyRequest;